import {
  ChevronDownIcon,
  ChevronRightIcon,
  ClipboardCopyIcon,
} from '@heroicons/react/outline';
import useLocale from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';

import clsxm from '@/lib/clsxm';
import { copyTextToClipboard } from '@/lib/copyTextToClipboard';

import MarkdownBlock from '@/components/Chat/MarkdownBlock';

type AIContentItemProps = {
  label: string;
  icon: JSX.Element;
  isLoading: boolean;

  item: string; // Adjust the type as necessary based on usage
  isAllOpened: boolean;
  toggleCounter: number;
};

const AIContentItem = ({
  label,
  icon,
  isLoading,

  item,
  isAllOpened,
  toggleCounter,
}: AIContentItemProps) => {
  const { t } = useLocale('transcription');
  const [isOpened, setIsOpened] = useState(isAllOpened);

  useEffect(() => {
    setIsOpened(isAllOpened);
  }, [isAllOpened, toggleCounter]);

  const handleCopyClick = (text: string) => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(text)
      .then(() => {
        toast.success(t('Copied successfuly 👍'), { duration: 1000 });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const toggleContent = () => {
    setIsOpened(!isOpened);
  };

  return (
    <div className='messages'>
      <div className='mt-16 flex justify-between'>
        <label
          htmlFor='prompt'
          onClick={toggleContent}
          className='flex cursor-pointer items-center justify-center text-xl font-medium text-gray-700 dark:text-slate-400'
        >
          <button
            type='button'
            className='inline-flex space-x-1 text-gray-900 hover:text-gray-500 dark:text-slate-400 hover:dark:text-slate-300'
            onClick={toggleContent}
          >
            {isOpened ? (
              <ChevronDownIcon className='h-5 w-5' aria-hidden='true' />
            ) : (
              <ChevronRightIcon className='h-5 w-5' aria-hidden='true' />
            )}
          </button>
          {icon}
          {t(label)}
        </label>
        <span
          className={clsxm(
            isOpened ? 'inline-flex' : 'hidden',
            'items-center text-sm',
          )}
        >
          <button
            type='button'
            className='ml-5 inline-flex space-x-1 text-gray-900 hover:text-gray-500 dark:text-slate-400 hover:dark:text-slate-300'
            disabled={!item}
            onClick={() => handleCopyClick(item)}
          >
            <ClipboardCopyIcon className='h-5 w-5' aria-hidden='true' />
            <span className='font-medium'>{t('Copy')}</span>
          </button>
        </span>
      </div>
      <div
        className={clsxm(
          isOpened ? 'flex' : 'hidden',
          'message dark:bg-slate-800 dark:text-slate-200',
        )}
      >
        <MarkdownBlock
          message={
            isLoading
              ? t('Generating') + '...'
              : (item && item.replace(/\n/g, '  \n').trim()) ||
                t('Click on the button to generate one')
          }
        />
      </div>
    </div>
  );
};

export default AIContentItem;
